import "./base.js";
import "../helpers/appointment_grid_date_fetcher.js";
import "../../../utilities/scroll_to_top.js";
import "../../../utilities/iso_date.js";
import "../../../shared/components/sparkle_loader.js";

AppointmentBooking.SlotPickerModal.Views.List = class List extends (
  AppointmentBooking.SlotPickerModal.Views.BaseTabView
) {
  static {
    this.prototype.className = "appointment-booking-slot-picker-modal-list";
    this.prototype.template = "appointment_booking/slot_picker_modal/templates/list";

    this.prototype.events = {
      "click [data-appointment-booking-slot-picker-modal-behaviour=show-more]": "handleClickShowMore",
      "click [data-slot-id]": "handleSlotClick",
    };
  }

  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.triggerSlotAction = this.triggerSlotAction.bind(this);
    this.render = this.render.bind(this);
    this.contextForRender = this.contextForRender.bind(this);
    this.scrollToSelectedDate = this.scrollToSelectedDate.bind(this);
    this.fetchAndReset = this.fetchAndReset.bind(this);
    this.fetchAndAdd = this.fetchAndAdd.bind(this);
    this.fetchDates = this.fetchDates.bind(this);
    this.recordEndDate = this.recordEndDate.bind(this);
    this.startDateForFocus = this.startDateForFocus.bind(this);
    this.hideOrShowMoreButton = this.hideOrShowMoreButton.bind(this);
  }

  initialize(options = {}) {
    this.options = options;
    super.initialize(options);
    this.options = _.defaults({}, this.options, { api: "slot_picker_modal_list" });
    this.originalFetchStartDate = this.startDateForFocus(this.model.get("focusDate"));
    this.fetchStartDate = this.originalFetchStartDate;

    this.loadingIndicator = new SparkleLoader().el;
    this.dateFetcher = new AppointmentBooking.SlotPickerModal.Helpers.AppointmentGridDateFetcher(this.options);
    this.appointmentGridDates = new AppointmentBooking.SlotPickerModal.Collections.AppointmentGridDates();

    // BEHAVIOUR

    return this.listenTo(this.model.get("filters"), "change", this.handleFilterChange);
  }

  // EVENT HANDLERS

  handleClickShowMore() {
    this.fetchStartDate = Sparkle.Utilities.isoDate(moment.parseZone(this.fetchEndDate).add(1, "day"));
    return this.fetchAndAdd().then(() => this.render());
  }

  handleFilterChange() {
    this.fetchStartDate = this.originalFetchStartDate; // We're resetting the filters and want to start pagination over again instead of continuing from the current offset
    return this.fetchAndReset().then(() => this.render());
  }

  handleSlotClick(e) {
    return this.triggerSlotAction(e);
  }

  triggerSlotAction(e) {
    const slot = this.appointmentGridDates.getSlot(jQuery(e.currentTarget).data("slot-id"));
    return jQuery(e.target).trigger(AppointmentBooking.SlotPickerModal.Events.slotPick, slot);
  }

  // RENDERING

  render() {
    if (this.fetched) {
      super.render(...arguments);
      this.$el.append(this.loadingIndicator);
      this.hideOrShowMoreButton();
    } else {
      this.fetched = true;
      this.fetchAndReset().then(() => {
        this.render();
        return this.scrollToSelectedDate();
      }); // Scroll to selected date after we fetch and render for the first time
    }

    return this;
  }

  contextForRender() {
    const context = super.contextForRender(...arguments);
    context.renderLinks = this.options.renderLinks != null ? this.options.renderLinks : true;
    return context;
  }

  scrollToSelectedDate() {
    const date = Sparkle.Utilities.isoDate(this.model.get("focusDate"));
    return Sparkle.Utilities.scrollToTop(this.$el.find(`[data-anchor=${date}]`));
  }

  // PRIVATE

  fetchAndReset() {
    return this.fetchDates().then((appointmentGridDates) => {
      this.appointmentGridDates.reset(appointmentGridDates, { silent: true });
      return this.recordEndDate();
    });
  }

  fetchAndAdd() {
    return this.fetchDates().then((appointmentGridDates) => {
      this.appointmentGridDates.add(appointmentGridDates, { silent: true });
      return this.recordEndDate();
    });
  }

  fetchDates() {
    this.loadingIndicator.show();
    const params = jQuery.extend({ after_date: this.fetchStartDate }, this.model.get("filters").toJSON());
    return this.dateFetcher
      .fetch(params)
      .always(() => this.loadingIndicator.hide())
      .then((page) => {
        this.hasMore = Boolean(page.more);
        return page.days;
      });
  }

  // Record the end date so we know where to start the next fetch
  recordEndDate() {
    let lastAppointmentGridDate;
    if (this.appointmentGridDates.last()) {
      lastAppointmentGridDate = this.appointmentGridDates.last().get("date");
    }

    if (lastAppointmentGridDate == null || moment.parseZone(lastAppointmentGridDate).isBefore(this.fetchStartDate)) {
      lastAppointmentGridDate = this.fetchStartDate;
    }

    if (lastAppointmentGridDate) {
      return (this.fetchEndDate = moment.parseZone(lastAppointmentGridDate));
    }
  }

  startDateForFocus(focusDate) {
    const min = moment.parseZone(focusDate).subtract(2, "weeks");
    const today = moment();
    const start = min.isBefore(today) ? today : min;
    return Sparkle.Utilities.isoDate(start);
  }

  hideOrShowMoreButton() {
    const $element = this.$el.find(".js-show-more");
    if (this.hasMore) {
      return $element.show();
    } else {
      return $element.hide();
    }
  }
};
